import React, { Component } from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import _ from "i18n";

import { isFiduciaryAccess } from "Utils";
import { selectCurrentOrganization } from "Selectors";
import {
  setCurrentNavPage,
  setDashboardListPaginationPage,
  setDashboardListFilterStatus,
  setDashboardListFilterisPublic,
  setDashboardListFilterTitle,
  setDashboardListFilterNewDashboardIds,
  setDashboardListFilter,
  setDashboardListPageSize
} from "actions";
import {
  fetchAvailableDashboard,
  fetchGeneralAssociationDashboard
} from "Thunks";

import DashboardList from "./DashboardList";
import DashboardFilter from "./DashboardFilter";
import { ICONS, SvgIcon } from "../Common/Icons";
import TTPPaginator from "../Common/TTPPaginator";
import PageHeader from "../Common/PageHeader/PageHeader";
import DashboardSlidesModal from "./DashboardSlidesModal";
import AssociationSlide from "../OrganizationList/AssociationSlide";
import classnames from "classnames";
import NotificationApi from "../../services/NotificationServices";
import { NotificationBar } from "../Common/Notification/NotificationBar";
import { getLabelsByLng, inIframe } from "../../utils";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";

class DashboardListPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedStates: ["ALL"],
      selectedDashboard: null,
      showDashboardsSlidesModal: false,
      isAssociationSlide: false,
      notifications: "",
      loading: false,
      loadingNotificationCrossSharing: false,
      closeNotification: false,
      notificationsCrossSharing: "",
      closeNotificationCrossSharing: false,
      isFilterNewDashboardActivated: false,
      dashboardsStatus: []
    };
  }
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(setCurrentNavPage("DASHBOARDS_LIST"));
    dispatch(setDashboardListFilterStatus([]));
    dispatch(setDashboardListFilterisPublic("", ""));
    dispatch(setDashboardListFilterTitle(""));
    dispatch(setDashboardListFilter(""));
    dispatch(setDashboardListPageSize(12));
    dispatch(setDashboardListFilterNewDashboardIds([]));
    this.handleGetNotificationDashboard();
    this.handleGetNotificationDashboardCrossSharing();
  }
  handleGetNotificationDashboard() {
    this.setState({ loading: true });
    const { currentOrganization, user } = this.props;
    NotificationApi.getNotificationDashboard(
      user.id,
      currentOrganization.uen
    ).then(response => {
      this.setState({
        notifications: response.data.data,
        loading: false
      });
    });
  }
  handleGetNotificationDashboardCrossSharing() {
    this.setState({ loadingNotificationCrossSharing: true });
    const { currentOrganization, user } = this.props;
    NotificationApi.getNotificationDashboardCrossSharing(
      user.id,
      currentOrganization.uen
    ).then(response => {
      this.setState({
        notificationsCrossSharing: response.data.data,
        loadingNotificationCrossSharing: false
      });
    });
  }
  handleCloseNotification = () => {
    const { dispatch, currentOrganization, user } = this.props;
    NotificationApi.closeNotification(
      user.id,
      currentOrganization.uen,
      "DASHBOARD"
    ).then(response => {
      this.setState({
        closeNotification: true
      });
      if (this.state.isFilterNewDashboardActivated) {
        dispatch(setDashboardListFilterNewDashboardIds([]));
      }
    });
  };
  handleNewDashboardList = () => {
    const { dispatch } = this.props;
    this.setState({
      isFilterNewDashboardActivated: true
    });
    dispatch(
      setDashboardListFilterNewDashboardIds(
        this.state.notifications.dashboardIds
      )
    );
  };
  handleSharedDashboardList = () => {
    const { dispatch } = this.props;
    this.setState({
      isFilterNewDashboardActivated: true
    });
    dispatch(
      setDashboardListFilterNewDashboardIds(
        this.state.notificationsCrossSharing.dashboardIds
      )
    );
  };
  handleCloseNotificationCrossSharing = () => {
    const { dispatch, currentOrganization, user } = this.props;
    NotificationApi.closeNotification(
      user.id,
      currentOrganization.uen,
      "DASHBOARD_SHARED"
    ).then(response => {
      this.setState({
        closeNotificationCrossSharing: true
      });
      if (this.state.isFilterNewDashboardActivated) {
        dispatch(setDashboardListFilterNewDashboardIds([]));
      }
    });
  };
  componentDidUpdate(prevProps, prevState) {
    const { filter, paginationPage, pageSize } = prevProps;
    if (
      filter !== this.props.filter ||
      paginationPage !== this.props.paginationPage ||
      pageSize !== this.props.pageSize
    ) {
      this.props.dispatch(fetchAvailableDashboard());
    }
  }

  handleDashboardListPageChange = ({ selected }) => {
    this.props.dispatch(setDashboardListPaginationPage(selected + 1));
  };

  handleCancelDashboardsSlidesModal = () => {
    this.setState({
      showDashboardsSlidesModal: false
    });
  };
  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };
  handleRedirectCreateDashboard = () => {
    this.props.dispatch(push("/composition/dashboard"));
  };

  handleDashboardsSlidesModal = dashboard => {
    this.setState({
      showDashboardsSlidesModal: true,
      selectedDashboard: dashboard
    });
  };
  renderPaginate() {
    let { dashboards, paginationPage, pageSize } = this.props;
    if (dashboards.error != null && dashboards.error.code === 404) {
      return "";
    }
    return (
      <TTPPaginator
        onPageChange={this.handleDashboardListPageChange}
        pageSize={pageSize}
        nbResult={dashboards.nbResult}
        paginationPage={paginationPage}
      />
    );
  }
  handleStateFilterChange = value => {
    this.setState({ selectedStates: value });
  };
  handleChangeDashboardsStatus = value => {
    this.setState({ dashboardsStatus: value });
  };

  onTabChange = value => {
    let { dispatch } = this.props;
    this.setState({ selectedStates: [value] });
    dispatch(setDashboardListFilter(""));
    dispatch(setDashboardListFilterNewDashboardIds([]));
    dispatch(setDashboardListFilterisPublic("", ""));

    if (value === "SHARED") {
      dispatch(setDashboardListFilterisPublic("false", "neq"));
    }
    if (
      value === "LIBRARY" ||
      value === "MyTemplates" ||
      value === "Templates"
    ) {
      dispatch(setDashboardListFilter(value));
    }
    dispatch(
      setDashboardListFilterStatus(
        value === "CREATED" || value === "STANDARD" ? [value] : []
      )
    );
  };
  //********* Sidebar functions **********//
  renderAddBubbleDisplayAssociationSlide = () => {
    const { isAssociationSlide } = this.state;
    return (
      <div className={classnames("setting-bubbles", "associate-bubbles")}>
        <div
          className={classnames(
            "circleSvg",
            isAssociationSlide ? "active openedAssociationSideBar" : ""
          )}
          onClick={() => this.onClickAssociateDashboard()}
        >
          <SvgIcon icon={ICONS.ASSOCIATE} />
          <span style={{ paddingLeft: "2.5rem" }}>{_("associate")}</span>
        </div>
      </div>
    );
  };

  onClickAssociateDashboard = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.remove("hide");
    document.body.classList.add("hidden_overflow");

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    this.setState({ isAssociationSlide: true });
    this.props.dispatch(fetchGeneralAssociationDashboard());
  };

  onCancelAssociateDashboard = () => {
    document
      .getElementsByClassName("mask")
      .item(0)
      .classList.add("hide");
    document.body.classList.remove("hidden_overflow");

    this.setState({
      isAssociationSlide: false
    });
    this.props.dispatch(fetchAvailableDashboard());
  };

  render() {
    let {
      dashboards,
      currentOrganization,
      withoutHeader,
      backOffice,
      preferences,
      lng
    } = this.props;
    let {
      selectedStates,
      selectedDashboard,
      isAssociationSlide,
      filterValue,
      notifications,
      loading,
      closeNotification,
      closeNotificationCrossSharing,
      notificationsCrossSharing,
      loadingNotificationCrossSharing,
      dashboardsStatus
    } = this.state;
    let filterFormIsVisible = false;
    let allowCreateDashboard =
      preferences && preferences.allowCreateDashboard === "1";
    let allowAssociateDashboards =
      preferences && preferences.allowAssociateDashboards === "1";
    return (
      <div
        className="page-content"
        style={{
          padding: withoutHeader ? "0px 0px 4.3rem 30px" : "0 0 4.3rem 0"
        }}
      >
        {inIframe() === false && (
          <div
            style={{
              marginBottom: "10px"
            }}
          >
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        {!backOffice &&
          !closeNotification &&
          notifications &&
          !loading &&
          notifications.notifications.length > 0 && (
            <div
              style={{
                marginBottom: "10px",
                marginLeft: withoutHeader ? "-30px" : ""
              }}
            >
              <NotificationBar
                message={
                  notifications.count.includes(1)
                    ? _("notifyNewDashboard") +
                      "'" +
                      getLabelsByLng(
                        notifications.notifications[0].dashboard,
                        lng
                      ) +
                      "'" +
                      _("notifyAtYourDisposal")
                    : notifications.count[0] + _("notifyNewDashboards")
                }
                theme="greenTeal"
                onSeeMore={this.handleNewDashboardList}
                onClose={this.handleCloseNotification}
              />
            </div>
          )}
        <div
          style={{
            marginLeft: withoutHeader ? "-30px" : ""
          }}
        >
          {!backOffice &&
            !closeNotificationCrossSharing &&
            notificationsCrossSharing &&
            !loadingNotificationCrossSharing &&
            notificationsCrossSharing.notifications.length > 0 && (
              <NotificationBar
                message={
                  notificationsCrossSharing.count.includes(1)
                    ? _("notifyNewSharedDashboard") +
                      "'" +
                      getLabelsByLng(
                        notificationsCrossSharing.notifications[0].dashboard,
                        lng
                      ) +
                      "'" +
                      _("notifyAtYourDisposal")
                    : notificationsCrossSharing.count[0] +
                      _("notifyNewSharedDashboards")
                }
                theme="greenTeal"
                onClose={this.handleCloseNotificationCrossSharing}
                onSeeMore={this.handleSharedDashboardList}
              />
            )}
        </div>
        <PageHeader
          header="templatesDashboard"
          subHeader="templatesDashboardSubHeader"
          icon={ICONS.DashboardList}
        >
          {(isFiduciaryAccess(currentOrganization) || backOffice) &&
            allowCreateDashboard && (
              <button
                className="btn secondary text-uppercase"
                onClick={() => this.handleRedirectCreateDashboard()}
              >
                <SvgIcon icon={ICONS.SIMPLE_PLUS_ICON} className={""} />
                {_("createDashboardTemplate")}
              </button>
            )}
        </PageHeader>
        {allowAssociateDashboards &&
          this.renderAddBubbleDisplayAssociationSlide()}
        <DashboardFilter
          filterFormIsVisible={this.handleFilterFormIsVisible}
          onStateFilterChange={this.handleStateFilterChange}
          selectedStates={selectedStates}
          handleChangeDashboardsStatus={this.handleChangeDashboardsStatus}
          onTabChange={this.onTabChange}
          isDashboardTemplateFrame={false}
        />
        <div
          className="row align-center medium-11"
          style={{ marginTop: "-7px" }}
        >
          <div className={`medium-12`}>
            <TTPFilterHorizontalBar
              onTabChange={this.onTabChange}
              tabs={backOffice ? [] : dashboardsStatus}
              selectedTab={selectedStates}
              cssClass="medium-12"
              HideButton={true}
            />
          </div>
        </div>
        <div>
          <DashboardList
            dashboards={dashboards.items}
            onDisplayDashboardSlides={this.handleDashboardsSlidesModal}
            selectedFilterValue={filterValue}
            newTag={notifications}
            closeNewTag={closeNotification}
          />
        </div>
        <div
          className={`row align-center margin-bottom-2 ${filterFormIsVisible &&
            "add-margin-left"}`}
        >
          <div
            className={
              filterFormIsVisible ? "column medium-12" : "column medium-11"
            }
          >
            {dashboards.fetched && dashboards.items.length ? (
              this.renderPaginate()
            ) : (
              <div className="row pagination" />
            )}
          </div>
        </div>
        <AssociationSlide
          isAssociationSlide={isAssociationSlide}
          handleCancelAssociationModal={this.onCancelAssociateDashboard}
        />
        <DashboardSlidesModal
          dashboard={selectedDashboard}
          isVisible={this.state.showDashboardsSlidesModal}
          handleCancelModal={this.handleCancelDashboardsSlidesModal}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  dashboard: state.dashboardList,
  currentOrganization: selectCurrentOrganization(state),
  dashboards: state.dashboardList,
  paginationPage: state.dashboardList.paginationPage,
  pageSize: state.dashboardList.pageSize,
  preferences: state.auth.preferences,
  filter: state.dashboardList.filter,
  withoutHeader: state.auth.withoutHeader,
  backOffice: state.params.backOffice,
  user: state.auth.user,
  lng: state.params.lng
});

export default connect(mapStateToProps)(DashboardListPage);



// WEBPACK FOOTER //
// ./src/components/DashboardList/DashboardListPage.js